<template>
    <a id="botaoVirtualizar" @click="$emit('virtualizarDocumento')" class="virtualizar__botao-link">
        <i class="fas fa-cloud-upload-alt" aria-hidden="true"/>
        Virtualizar
    </a>
</template>

<script>
export default {
    name: 'BotaoVirtualizar'
}
</script>

<style scoped lang="stylus">
    .virtualizar
        color #888
        &__botao-link
            background-color #fff
            color #888
            padding 5px 10px 7px 5px
            min-width 50px
            border 0.1px solid #CACFD2

            i
                color #777 !important
                font-size 13px
                top 0

            &:hover, &:active, &:focus
                background-color #e4e4e4
                padding 3px 8px 5px 3px
                border 3px solid #CACFD2
                border-radius 4px

</style>
